export const PHONE_COMPLETION_PATH = '/profile/phone'
export const SIGN_UP_PHONE_PREFILL_SESSION_KEY = 'fitro_signup_phone_prefill'
const PHONE_COMPLETION_SESSION_STORAGE_PREFIX = 'phone-completion-dismissed'

export const buildPhoneCompletionSessionKey = (userId: string | null | undefined, partnerSlug: string) =>
    `${PHONE_COMPLETION_SESSION_STORAGE_PREFIX}:${userId ?? 'anonymous'}:${partnerSlug}`

export const extractPolishDigits = (phone: string): string => {
    const digits = phone.replace(/\D/g, '')
    if (digits.startsWith('48') && digits.length === 11) return digits.slice(2)
    if (digits.length === 9 && /^[1-9]/.test(digits)) return digits
    return ''
}

export const normalizePolishPhone = (raw: string): string | null => {
    const trimmed = raw.trim()
    if (!trimmed) return null

    let cleaned = ''
    for (const char of trimmed) {
        if (/\s|-|\(|\)/.test(char)) continue
        cleaned += char
    }

    if (cleaned.startsWith('00')) {
        cleaned = `+${cleaned.slice(2)}`
    }

    const isNational = (value: string) => /^[1-9][0-9]{8}$/.test(value)

    if (cleaned.startsWith('+48')) {
        const digits = cleaned.slice(3)
        return isNational(digits) ? `+48${digits}` : null
    }
    if (cleaned.startsWith('48')) {
        const digits = cleaned.slice(2)
        return isNational(digits) ? `+48${digits}` : null
    }
    return isNational(cleaned) ? `+48${cleaned}` : null
}
